const Platform = {
  // constants
  OS_UNKNOWN: "unknown",
  OS_WINDOWS: "windows",
  OS_MAC: "mac",
  OS_LINUX: "linux",

  os: "unknown",
  mobile: false
};

const userAgent = window.navigator.userAgent.toLowerCase();
const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(
  window.navigator.appVersion);

for (const item of ["windows", "mac", "linux"])
{
  if (userAgent.includes(item))
  {
    Platform.os = item;
    break;
  }
}

Platform.mobile = mobile;

export { Platform };